var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"carousel-image",attrs:{"src":_vm.image_source,"id":`carousel-image-${_vm.index}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }